import {UA_SUCCESS} from '../get-audits/constants'
import {closeIndividualAudit as closeIndividualAuditAPI} from '../../../services/audits'

export async function closeIndividualAudit(id, data = null, dispatch) {
  try {
    let response = await closeIndividualAuditAPI(id, data)
    dispatch({type: UA_SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Close Audit Failed`)
    return e.response
  }
}
